import { Color } from '@millionshow/client-libs';

export type SourceType =
  | 'MILLIONSHOW'
  | 'ALLHOUSE'
  | 'GOODSPACE'
  | 'AGRITEX'
  | 'STARTFAIR'
  | 'GIFTFAIR';

export const SOURCE_TYPE_BADGE_PROPS: Record<
  SourceType,
  { color: Color; text: string }
> = {
  MILLIONSHOW: { color: 'primary', text: '밀리언쇼' },
  ALLHOUSE: { color: 'info', text: '올하우스' },
  GOODSPACE: { color: 'primary', text: '좋은공간' },
  AGRITEX: { color: 'success', text: '애그리텍스' },
  STARTFAIR: { color: 'warning', text: '스타트페어' },
  GIFTFAIR: { color: 'secondary', text: '기프트페어' },
};
